/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState } from "react";
import { IModal, InitialModal, ModalContext } from "app/context/useModal";

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [modal, setModal] = useState<IModal>(InitialModal);
  const open = (modal: IModal) => {
    setModal((prev) => ({
      ...prev,
      show: true,
      title: modal.title,
      desc: modal.desc,
      click: modal.click,
    }));
  };
  const close = () => setModal((prev) => ({ ...prev, ...InitialModal }));
  return (
    <ModalContext.Provider value={{ modal, open, close }}>
      {children}
    </ModalContext.Provider>
  );
};
